import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment:ENV = {
    production: false,
    apiUrl: 'https://sas.gateway.test.todotix.net/', // TEST
    bridgeUrl: 'https://bridge.test.todotix.net/', // TEST
    assetsUrl: 'https://sas.assets.test.todotix.net/', // TEST
    tenant: 'sas',
    providerId: '5ba7fdc1-3a4e-44de-ae14-1b451bb63263',
    type: 'sas',
    title: `Saint Andrew's School`,
    subtitle: 'Pagos',
    description: `"Saint Andrew's School" es un sitio en el que puedes administrar tus cuentas y pagos`,
    keywords: 'SAS, pagos, sas, cuentas, sas cuentas, sas pagos',
    yearProyect: '2025',
    imgLogoIcon: '/assets/img/logo.png',
    imgLogoIconWhite: '/assets/img/logo-white.png',
    imgLogo: '/assets/img/logo-white.png',
    imgLogoSVG: '/assets/img/logo.png',
    imgLogoWhiteSVG: '/assets/img/logo-white.png',
    imgLogoWhite: '/assets/img/logo-white.png',
    imgLogoHeader: '/assets/img/logo-white.png',

    templateType: 'template-4',
    theme: 'light',
    changeTheme: false,

    authGoogle: false,
    authFacebook: false,
    authApple: false,
    authGithub: false,

    authRedirect: '/my-accounts',

    loaderType: 1,
    loaderDefaultText: 'Cargando...',

    //* Firebase
    firebase: {},

    keyEncrypt: '3fa85f64c2f9e0c53fa85f64c2f9e0c5',
    ivEncrypt: '3fa85f64c2f9e0c5',

    // BRIDGE SECRET KEYS
    xApiKey: '1702c3fa-36cb-4886-989e-f2411243afc1',
    xSecretKey: '35f0b745-169b-45fe-9234-1f378bb60036',
};
